import { ViewModelService } from 'src/app/shared/view-model.service';
import { PassengerType } from 'src/graphql/generated/graphql.generated';
import { PersonViewModel } from 'src/models/person-view-model';
import { TripViewModel } from 'src/models/trip-view-model';
import {
  TripPassengerRecord,
  TripPassengerViewModelBase,
} from 'src/store/generated/trip-passenger-record.generated';
import { humanize } from 'src/util/text';

interface PassengerTypeConfig {
  icon: string;
}

const passengerTypeConfig: { [key in PassengerType]: PassengerTypeConfig } = {
  CrewMember: {
    icon: 'fc_medic_bag',
  },
  Escort: {
    icon: 'person',
  },
  Guard: {
    icon: 'person',
  },
  Other: {
    icon: 'person',
  },
  Patient: {
    icon: 'fc_patient',
  },
  PilotInCommand: {
    icon: 'fc_pilot',
  },
  CoPilot: {
    icon: 'fc_pilot',
  },
  SpecialtyTeamMember: {
    icon: 'person_outline',
  },
  Driver: {
    icon: 'fc_pilot',
  },
  RideAlong: {
    icon: 'supervisor_account',
  },
};

export class TripPassengerViewModel extends TripPassengerViewModelBase {
  public readonly trip: TripViewModel;
  public readonly person?: PersonViewModel;
  get config(): PassengerTypeConfig {
    return passengerTypeConfig[this.type];
  }
  get typeDisplay() {
    return this.type === 'CoPilot' ? 'Co-Pilot' : humanize(this.type);
  }
  get icon() {
    return this.config.icon;
  }
  constructor(
    passenger: TripPassengerRecord,
    trip: TripViewModel,
    person: PersonViewModel | undefined,
    private readonly _model: ViewModelService,
  ) {
    super(passenger);
    this.trip = trip;
    this.person = person;
  }
}
